import { connect } from "react-redux";
import PremierHero from "../../components/PremierHero/index.jsx";

const mapStateToProps = (state) => ({
  premierDeliveryBanner: state.PremierPageFrame.content.premierDeliveryBanner,
  assetsUrl: state.Environment.assetsUrl,
});

export default connect(mapStateToProps)(PremierHero);
